import React from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '@material-ui/core/'
import { withStyles } from '@material-ui/core/styles'
import { mdiAccountPlus } from '@mdi/js'

import DoorAccessFormDialog from './DoorAccessFormDialogContainer'
import TooltipButton from '../controls/TooltipButton'

class CreateDoorAccessButton extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    communityId: PropTypes.number.isRequired,
  }

  static styles = () => ({
    buttonRoot: {
      borderRadius: 25,
      minHeight: 40,
      '& svg': {
        marginRight: 5,
      },
    },
  })

  state = {
    openDialog: false,
  }

  handleClick = () => {
    this.setState({ openDialog: true })
  }

  handleDialogClose = () => {
    this.setState({ openDialog: false })
  }

  render() {
    return (
      <>
        <TooltipButton
          classes={{ root: this.props.classes.buttonRoot }}
          onClick={this.handleClick}
          variant="outlined"
        >
          <SvgIcon>
            <path d={mdiAccountPlus} />
          </SvgIcon>
          Create User
        </TooltipButton>

        <DoorAccessFormDialog
          communityId={this.props.communityId}
          onClose={this.handleDialogClose}
          open={this.state.openDialog}
        />
      </>
    )
  }
}

export default withStyles(CreateDoorAccessButton.styles)(CreateDoorAccessButton)
